// Building blocks of the explanatory pages (House, Papurr): a question with its plain-words answer, figures and
// lines that each carry a "?" hint for the term they show.
import type { ReactNode } from 'react';

/** A small "?" whose tooltip explains the term next to it */
export function Hint({ text }: { text: string }) {
  return (
    <span className="hint" title={text} aria-label={text} role="img">
      ?
    </span>
  );
}

/** A headline number; `children` (an action button) sits under it */
export function Figure({
  label,
  hint,
  value,
  sub,
  tone: t,
  children,
}: {
  label: string;
  hint: string;
  value: string;
  sub?: string;
  tone?: string;
  children?: ReactNode;
}) {
  return (
    <div className="house-figure">
      <span className="house-figure-label">
        {label} <Hint text={hint} />
      </span>
      <b className={`num ${t ?? ''}`}>{value}</b>
      {sub && <span className="house-figure-sub">{sub}</span>}
      {children}
    </div>
  );
}

export function Question({ title, lead, children }: { title: string; lead: string; children: ReactNode }) {
  return (
    <section className="panel house-q">
      <h3>{title}</h3>
      <p className="house-q-lead">{lead}</p>
      {children}
    </section>
  );
}

export function Line({ label, hint, value, sub, tone: t, strong }: { label: string; hint?: string; value: string; sub?: string; tone?: string; strong?: boolean }) {
  return (
    <div className={`house-line ${strong ? 'strong' : ''}`}>
      <span className="house-line-label">
        {label} {hint && <Hint text={hint} />}
      </span>
      <span className="house-line-value">
        <b className={`num ${t ?? ''}`}>{value}</b>
        {sub && <small>{sub}</small>}
      </span>
    </div>
  );
}
